import styled from 'styled-components'
import Clear from '@material-ui/icons/Clear'
import { Typography } from '@material-ui/core'
import { px2rem } from '../../../theme/Global'

export const ExpiredSessionModalContainer = styled.div`
  background-color: #f5f5f5;
`

export const ExpiredSessionModalCloseButton = styled(Clear)`
  position: absolute;
  cursor: pointer;
  right: 0;
  top: 0;
  margin: 1rem;
`

export const ExpiredSessionModalMessageTypography = styled(Typography)`
  font-size: ${px2rem(18)}rem;
`

export const ExpiredSessionModalTitleTypography = styled(Typography)`
   ${ExpiredSessionModalMessageTypography};
   font-weight: 600;
`

export const ExpiredSessionModalHardRule = styled.hr`
  width: 100%;
  height: ${px2rem(3)}rem;
  -webkit-backdrop-filter: blur(${px2rem(5)}rem);
  backdrop-filter: blur(${px2rem(5)}rem);
  background-image: linear-gradient(to bottom, #3e6c90, #b0d3ea);
`
